/* jshint ignore:start */

var GoToManager = (function($) {
    // console.log("llamada a config idioma");
    var instance;

    function init() {

        var _$goTo;

        return {
            initCommon: function() {
                _$goTo.on('click', function(ev) {
                    ev.preventDefault();

                    var scrollID = $(this).attr('href');
                    var $scrollID = $(scrollID);

                    if ($scrollID.length) {
                        $('html, body').animate({
                            scrollTop: $scrollID.offset().top
                        }, 1000);
                    }
                });
            },


            init: function() {
                _$goTo = $('.js-go-to');

                if (_$goTo.length) {
                    // console.log('más cursos inittttt');
                    this.initCommon();
                }
            }
        };
    }


    return {

        getInstance: function(){

            if (!instance){
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */

